import { CaretDown } from '@phosphor-icons/react';

export default CaretDown;
